import React from 'react';
import './ComparisonTable.css';

const ComparisonTable = () => {
  const comparisonData = [
    {
      feature: '功能范围',
      v2: '盘前计划 + 交易心得 + 价格警报',
      v1: '基础交易记录'
    },
    {
      feature: '数据结构',
      v2: '结构化记录：计划-执行-复盘',
      v1: '简单日记形式'
    },
    {
      feature: '价格警报',
      v2: '✅ 实时监控，Telegram/Discord推送',
      v1: '❌ 不支持'
    },
    {
      feature: '移动端优化',
      v2: '✅ 完全适配，触屏友好',
      v1: '⚠️ 基础支持'
    },
    {
      feature: '数据同步',
      v2: '✅ Supabase 云端同步',
      v1: '⚠️ 本地存储为主'
    },
    {
      feature: '适用场景',
      v2: '专业交易者，需要系统化记录',
      v1: '入门用户，轻量化记录'
    }
  ];

  return (
    <div className="comparison-section">
      <div className="container">
        <h2 className="comparison-title">版本对比 - 选择适合你的方案</h2>
        <p className="comparison-subtitle">
          了解新版 v2 与旧版 v1 的功能差异，选择最适合你交易风格的版本
        </p>
        
        <div className="comparison-table-wrapper">
          <table className="comparison-table">
            <thead>
              <tr>
                <th className="comparison-table__header comparison-table__feature">功能对比</th>
                <th className="comparison-table__header comparison-table__v2">
                  <div className="version-header">
                    <span className="version-title">新版 v2</span>
                    <span className="version-badge version-badge--new">推荐</span>
                  </div>
                </th>
                <th className="comparison-table__header comparison-table__v1">
                  <div className="version-header">
                    <span className="version-title">旧版 v1</span>
                    <span className="version-badge version-badge--classic">经典</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, index) => (
                <tr key={index} className="comparison-table__row">
                  <td className="comparison-table__cell comparison-table__feature-cell">
                    <strong>{row.feature}</strong>
                  </td>
                  <td className="comparison-table__cell comparison-table__v2-cell">
                    {row.v2}
                  </td>
                  <td className="comparison-table__cell comparison-table__v1-cell">
                    {row.v1}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="comparison-cta">
          <div className="comparison-cta__item">
            <a 
              href="/plan" 
              className="btn btn-primary comparison-cta__button"
            >
              体验新版 v2
            </a>
            <p className="comparison-cta__note">完整功能，现代化体验</p>
          </div>
          <div className="comparison-cta__item">
            <a 
              href="https://v1.mycryptooverview.com" 
              className="btn btn-secondary comparison-cta__button"
              target="_blank"
              rel="noopener noreferrer"
            >
              继续使用 v1
            </a>
            <p className="comparison-cta__note">简单稳定，数据可导出</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComparisonTable;